import React from "react";
import "./Healthcare.css";
import Navbar from "../components/Navbar";

const AerospaceAndAutomobile = () => {
  return (
    <>
      <Navbar />
      <div className="industry1-container">
        <div className="industry1-content">
          <p className="para">Industries / Aerospace & Automobile</p>
          <h2>Aerospace & Automobile</h2>
          <p className="subtitle1">
            Engineering Precision and Innovation through Immersive Technologies
          </p>
          <p>
            At Spatial Computing Technologies (SpatialCT), we work with automobile and aerospace
            leaders to integrate XR (Extended Reality), AI, and Spatial Computing into their design,
            prototyping, training, and operational workflows. Our immersive solutions address complex
            industrial challenges, reduce development costs, and boost workforce efficiency and safety.

          </p>

          {/* Grid Content */}
          <div className="industry1-grid">
            <div className="industry1-row">
              <div className="industry1-box">
                <h4>Immersive Prototyping & Virtual Mockups</h4>
                <p>
                 Create and test digital twins of vehicle components, interiors, or aircraft assemblies before 
                  committing to physical prototypes. Our VR-based systems support real-time design reviews, 
                    component fit checks, and spatial ergonomics validation.
                </p> 
                <ul>
                  <li>Integrates with CAD and BIM files</li>
                  <li>Supports collaborative remote reviews</li>
                  <li>Reduces design-to-production cycle</li>
                </ul>
                <p>
                  <strong>Ideal for:</strong> Automotive design teams, aerospace
                  engineering divisions
                </p>
              </div>

              <div className="industry1-box">
                <h4>Assembly Line Simulation & Worker Training</h4>
                <p>
                              Our VR training modules replicate entire manufacturing and assembly workflows for cars, aircraft, 
or parts. Workers learn by doing — using interactive tools and guided steps inside virtual factory 
environments.
                </p>
                <ul>
                  <li>Tracks performance metrics and response times</li>
                  <li>Reduces training overhead and production downtime</li>
                  <li>Safe space for learning error-prone or hazardous steps</li>
                </ul>
                <p>
                  <strong>Ideal for:</strong> Manufacturing units, onboarding teams
                </p>
              </div>
            </div>

            <div className="industry1-row">
              <div className="industry1-box">
                <h4>Immersive Maintenance & Safety Protocol Training</h4>
                <p>
                         imulate high-risk environments such as engine maintenance, fuel leak response, or brake system 
failures to prepare technicians and engineers for real-world crises. 
                </p>
                <ul>
                  <li>Scenario-based learning with stress monitoring</li>
                  <li>Enhances muscle memory and hazard recognition</li>
                  <li>Supports compliance and audit readiness</li>
                </ul>
                <p>
                  <strong>Ideal for:</strong> Maintenance divisions, compliance and safety teams
                </p>
              </div>

              <div className="industry1-box">
                <h4>Virtual Showrooms & Client Demonstrations</h4>
                <p>
                 Offer buyers and clients the ability to interact with fully rendered car or aircraft interiors in VR, 
customize features, and understand component functionalities before production.
                </p>
                <ul>
                  <li>Real-time configurable trims, lighting, ergonomics</li>
                  <li>Supports touchscreen, VR headset, or web deployment</li>
                  <li>Builds pre-launch engagement</li>
                </ul>
                <p>
                  <strong>Ideal for:</strong> Marketing, sales, customer experience
                  teams
                </p>
              </div>
            </div>

            <div className="industry1-row">
              <div className="industry1-box">
                <h4>Collaborative Design & Review Environments</h4>
                <p>   Enable distributed engineering teams to collaborate inside virtual environments. Review designs, 
troubleshoot systems, or simulate environments from multiple locations.
                    </p>
                <ul>
                  <li>Supports multi-user VR sessions</li>
                  <li>Shared annotations, voice, and 3D interaction</li>
                  <li>Enhances feedback cycles and reduces silos</li>
                </ul>
                <p>
                  <strong>Ideal for:</strong> Global product teams, innovation labs
                </p>
              </div>
            </div>
          </div>

          {/* Use Cases Table */}
          <div className="usecases-section">
            <h3>Use Cases At a Glance</h3>
            <div className="table-wrapper">
              <div className="usecases-table">
                <div className="usecases-row usecases-header">
                  <div>Use Case</div>
                  <div>Industry</div>
                  <div>Solution Type</div>
                  <div>Benefits</div>
                </div>
                <div className="usecases-row">
                  <div>VR Car Interior Configurator</div>
                  <div>Automotive</div>
                  <div>Customer Demo</div>
                  <div>Enhanced engagement, improved sales</div>
                </div>
                <div className="usecases-row">
                  <div>Aircraft Cabin Layout Simulator</div>
                  <div>Aerospace</div>
                  <div>Prototyping</div>
                  <div>Faster design iterations</div>
                </div>
                <div className="usecases-row">
                  <div>Assembly Line Training</div>
                  <div>Both</div>
                  <div>Workforce Training</div>
                  <div>Reduced errors, safer onboarding</div>
                </div>
                <div className="usecases-row">
                  <div>Safety Drill Simulations</div>
                  <div>Aerospace</div>
                  <div>Compliance Training</div>
                  <div>Increased preparedness, regulatory adherence</div>
                </div>
                <div className="usecases-row">
                  <div>Remote Design Reviews</div>
                  <div>Both</div>
                  <div>XR Collaboration</div>
                  <div>Faster decisions, global team synergy</div>
                </div>
              </div>
            </div>
            <div className="usecases-cta">
              <h4>Let’s Build the Future of Mobility Together</h4>
              <p>
                   Whether you're optimizing a factory floor, training your workforce, or launching your next vehicle, 
                  SpatialCT's XR solutions can fast-track your innovation. 
              </p>
              <p>
                <strong>Contact us</strong> for a free consultation or live demo tailored to your business.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AerospaceAndAutomobile;
